import * as React from 'react';
import { useState } from 'react';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Box from '@mui/material/Box';
import Portfoliocard from './Portfoliocard';
function Portfolio() {
  const projects = [
    {
      id:7,
      title: "Microsite for Millenial-Centric Real Estate Property",
      category: "Web",
      imageUrl: "https://cdn.prod.website-files.com/61962f94f13cb612b8c209e2/620d05445ae7bd1b6ca7909d_26ny_RealEstateMicrosite.jpg",
      link: "/portfolio",
    },
    {
      id:8,
      title: "Shopify: Spreading Love & Freshwater",
      category: "E-Commerce",
      imageUrl: "https://cdn.prod.website-files.com/61962f94f13cb612b8c209e2/620d04d1651f9389dd31192c_LoveAndFreshwaterSqr.jpg",
      link: "/portfolio",
      customStyle: { marginLeft: { xs: 'auto', md: '220px' } }
    },
    {
      id:9,
      title: "COVID Fundraiser UI/UX Design Services",
      category: "UI/UX",
      imageUrl: "https://cdn.prod.website-files.com/61962f94f13cb612b8c209e2/620d037d31c69ae6457048e8_DoctorMaskVideo.jpg",
      link: "/portfolio",
    },
    {
      id:10,
      title: "Interactive Guidebooks for Airbnbs",
      category: "Web",
      imageUrl: "https://cdn.prod.website-files.com/61962f94f13cb612b8c209e2/620d05b34702fc8246f0f328_WistfullyIntro2.jpg",
      link: "/portfolio",

    },
    {
      id:11,
      title: "AI-Powered Healthcare Dashboard",
      category: "Data Analytics",
      imageUrl: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQO7vgxsPgN_mwgut9_tes7ueUJ9xxJqtkBjQ&s",
      link: "/portfolio",
      customStyle: { marginLeft: { xs: 'auto', md: '220px' } }
    },
    {
      id:12,
      title: "Virtual Event Platform for Conferences",
      category: "Event Management",
      imageUrl: "https://www.consoftservices.com/img/services/virtual-event/in-person-virtual-conferences.jpg",
      link: "/portfolio",
      customStyle: { marginLeft: { xs: 'auto', md: '175px' } }
    },
  ];

  const [showPortfolio, setShowPortfolio] = useState(false);

  const handleSeeMoreClick = () => {
    setShowPortfolio(true);
  };
  return (
    <>
      <div className='portfolio_section'>
        <div className='services_title_con wow animate__fadeInUp' data-wow-duration="1s">
          <h2 className='services_title'>Portfolio</h2>
          <p className='services_paragraph'>Below are a few projects that we've worked on.</p>
        </div>
        <div className='portfolio_bottom'>
          <div className='portfolioheader'>
            <div>
              <div className='portfolio_anchor_con'>

                <a className='portfolio_author_image_con wow animate__fadeInUp' data-wow-duration="1s" href="/portfolio">
                  <div className='portfolio_card_author'>
                    <div className='category_portfolio_container'>
                      <div>
                        <div className='category_tag_portfolio'>
                          <div className='multitextblurgradiantportfolio'></div>
                          <div>
                            <div className='multitextportfolio'>
                              Multi-Platform
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <h2 className='portfoliotitle'>Blackbox Testing the Yelp for those with Disabilities</h2>
                    <p className='portfolioparagraph'>To build a crowd-sourced review platform for people with disabilities and effectively perform Black-box testing.</p>
                    <div className='portfolio_author_container'>
                      <div className='portfolio_image_container'>
                        <img className='portfolioclientimage' src="https://cdn.prod.website-files.com/61962f94f13cb612b8c209e2/62166f42de6d5a2af5ad52de_NetAesthetics_Client-Logo_ERC.jpg" alt="" />
                      </div>
                      <div>
                        <div className='portfolio_author_name'>Equal Rights Center</div>
                        <div>Client</div>
                      </div>
                    </div>
                  </div>
                  <div className='portfolio_mainimage_container'>
                    <img className='mainimage' src="https://cdn.prod.website-files.com/61962f94f13cb612b8c209e2/620d1e472b488cb717066e52_wheelchair_access_A11y.jpg" alt="" />
                  </div>
                </a>

              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='divider'>
        <div></div>
      </div>
      <div className='blog_container'>
        <h2 className='services_title wow animate__fadeInUp' data-wow-duration="1s" style={{ marginBottom: '50px', marginTop: '130px' }}>
          Other Project
        </h2>
        <div className='blog_section wow animate__fadeInUp' data-wow-duration="1s">
          {projects.map((project, index) => (
            <Card className='muicard' key={index}>
              <Box
                sx={{
                  position: 'relative',
                  height: 265,
                  backgroundImage: `url(${project.imageUrl})`,
                  backgroundPosition: 'center',
                  backgroundSize: 'cover',
                  backgroundRepeat: 'no-repeat',
                }}
              >
                <Box className="categorytext" sx={project.customStyle}>
                  {project.category}
                </Box>
              </Box>
              <CardContent style={{textAlign:'left'}}>
                <a href={`/portfolio/${project.id}`}  className='typographytext' variant="body2">
                  {project.title}
                </a>
              </CardContent>
              <CardActions sx={{
                flexDirection: 'column',
                textAlign: 'left',
                alignItems: 'flex-start',
              }}>
                <a  href={`/portfolio/${project.id}`} className='muireadmore'>Read More <span className="arrow_icon"> ↗</span></a>
                <div className='underline_animation'></div>
              </CardActions>
            </Card>
          ))}
        </div>
      </div>
      <div className='blog_container'>
        <div className='seemore_con' style={{ display: showPortfolio ? 'none' : 'block',marginBottom:'30px' }}>
          <a style={{cursor:'pointer'}} onClick={handleSeeMoreClick}>
            See More Projects <svg class="w-pagination-next-icon" height="12px" width="12px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" transform="translate(0, 1)"><path fill="none" stroke="currentColor" fill-rule="evenodd" d="M4 2l4 4-4 4"></path></svg>
          </a>
        </div>
      </div>
      <div className={`blog_container ${showPortfolio ? '' : 'd-none'}`} >
        <Portfoliocard />
      </div>

    </>
  )
}

export default Portfolio